import React from 'react';

const DateCard = (date) => {
  const dateTime = new Date(date.date);

  if (isNaN(dateTime.getTime())) {
    return <div className="c-date-card__invalid">Ogiltigt datum</div>;
  }

  const day = dateTime.getDate();
  const month = dateTime.getMonth();
  const year = dateTime.getFullYear();

  const getMonthName = (monthNumber, shortenMonthName) => {
    const monthNames = Array.from({ length: 12 }, (_, i) => {
      const date = new Date(dateTime.getFullYear(), i, 1);
      const month = date.toLocaleString('sv-SE', { month: 'long' });
      return shortenMonthName ? month.slice(0, 3) : month;
    });

    return monthNames[monthNumber];
  };

  return (
    <div className="c-date-card__container">
      <div className="c-date-card__day">{day}</div>
      <div className="c-date-card__month__long">{getMonthName(month, false)}</div>
      <div className="c-date-card__month__short">
        {getMonthName(month, true)}
      </div>
      <div className="c-date-card__year">{year}</div>
    </div>
  );
};

export default DateCard;
